export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/index.js
// module id = 417
// module chunks = 2